import { mocked } from '@/configs';
import { Constructor } from '@/type-utils';

import MockService, { MockState, ServiceMock } from '../MockService';

import type { ContentService } from './ContentService';
import { MOCK_CONTENT } from './mocks/MOCK_CONTENT';

const initialState = {};

/** Mock implementation of the `ContentService` class. */
export default class ContentServiceMock extends ServiceMock<ContentService> {
  protected _state;

  /** @inheritdoc */
  public get state(): MockState {
    return this._state;
  }

  /** @inheritdoc */
  public getMock(): ContentService {
    return MockService.getMockOf(this.service) as unknown as ContentService;
  }

  /**
   * The constructor to initialize the mocks.
   * @param service - The base service.
   */
  public constructor(private service: Constructor<ContentService>) {
    super();
    this._state = new MockState(initialState);
    this.initializeMockedMembers(service);
  }

  /** @inheritdoc */
  protected initializeMockedMembers(
    service: Constructor<ContentService>
  ): void {
    const mockEnabled: boolean = mocked.ContentService;
    MockService.mockService(
      mockEnabled,
      service,
      {
        getContent: async () => {
          return Promise.resolve(MOCK_CONTENT);
        }
      },
      {},
      this.state
    );
  }
}
